import React, { useState } from "react";
import { Container, Row, Col, Button } from "reactstrap";

import Highlight from "../components/Highlight";
import Loading from "../components/Loading";
import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";

export const ProfileComponent = () => {
  const { user, getAccessTokenSilently } = useAuth0();
  const [state, setState] = useState({
    showToken: false,
    apiToken: "",
    error: null
  });

  const fetchApiToken = async () => {
    try {
      const token = await getAccessTokenSilently();
      console.log(token);
      setState({
        ...state,
        showToken: true,
        apiToken: token,
      });
    } catch (error) {
      setState({
        ...state,
        error: error.error,
      });
    }
  };

  return (
    <Container className="mb-5">
      <Row className="align-items-center profile-header mb-5 text-center text-md-left">
        <Col md={2}>
          <img
            src={user.picture}
            alt="Profile"
            className="rounded-circle img-fluid profile-picture mb-3 mb-md-0"
          />
        </Col>
        <Col md>
          <h2>{user.name}</h2>
          <p className="lead text-muted">{user.email}</p>
        </Col>
      </Row>
      <Row>
        <Highlight>{JSON.stringify(user, null, 2)}</Highlight>
      </Row>
      <Row>
        <Button
          color="primary"
          className="mt-5"
          onClick={fetchApiToken}
        >
          Get API Token
        </Button>
      </Row>
      <Row className="mt-3"> {state.showToken && (
        <Highlight>
          {state.apiToken}
        </Highlight>)}
      </Row>
    </Container>
  );
};

export default withAuthenticationRequired(ProfileComponent, {
  onRedirecting: () => <Loading />,
});
